const ListLGIcon = ({ onClick }: { onClick: (val: 'lg') => void }) => {
  return (
    <svg
      width="32"
      height="32"
      onClick={() => {
        onClick('lg');
      }}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29 0H3C1.34312 0 0 1.34312 0 3V29C0 30.6569 1.34312 32 3 32H29C30.6569 32 32 30.6569 32 29V3C32 1.34312 30.6569 0 29 0ZM30 29C30 29.5523 29.5523 30 29 30H3C2.44769 30 2 29.5523 2 29V3C2 2.44769 2.44769 2 3 2H29C29.5523 2 30 2.44769 30 3V29Z"
        fill="black"
      />
      <path
        d="M21.7096 17.2901C21.3196 16.9023 20.6897 16.9023 20.2996 17.2901L17.9996 19.5901L13.7096 15.3001C13.3196 14.9123 12.6897 14.9123 12.2996 15.3001L5.29963 22.3001C4.913 22.6945 4.91919 23.3276 5.31356 23.7142C5.497 23.8941 5.74269 23.9965 5.99963 24.0001H25.9996C26.5519 24.0033 27.0022 23.5582 27.0054 23.0059C27.007 22.7372 26.9004 22.4793 26.7096 22.2901L21.7096 17.2901Z"
        fill="black"
      />
      <path
        d="M19 14C20.6569 14 22 12.6569 22 11C22 9.34315 20.6569 8 19 8C17.3431 8 16 9.34315 16 11C16 12.6569 17.3431 14 19 14Z"
        fill="black"
      />
    </svg>
  );
};

export default ListLGIcon;
